export default __webpack_public_path__ + "static/media/successNot.a673b70c.wav";